var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "knowledge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.493,
    height: 37.637,
    viewBox: "0 0 33.493 37.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52914",
    "data-name": "Path 52914",
    d: "M34.423,251.99H51.169v19.122H34.423Z",
    transform: "translate(-34.423 -233.474)",
    fill: "#fd7a6e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52915",
    "data-name": "Path 52915",
    d: "M34.423,251.99h1.218v19.122H34.423Z",
    transform: "translate(-34.423 -233.474)",
    fill: "#fb695b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52916",
    "data-name": "Path 52916",
    d: "M256,251.99h16.746v19.122H256Z",
    transform: "translate(-239.254 -233.474)",
    fill: "#fb695b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45608",
    "data-name": "Group 45608",
    transform: "translate(2.31 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52917",
    "data-name": "Path 52917",
    d: "M79.422,242.858l.132-2.909.642-8.672-.775-7.54a2.41,2.41,0,0,0-2.31-2.31H64.986v19.122H77.113a2.317,2.317,0,0,1,2.31,2.31Z",
    transform: "translate(-64.986 -205.221)",
    fill: "#f3f5fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52918",
    "data-name": "Path 52918",
    d: "M256,242.859V223.738a2.317,2.317,0,0,1,2.31-2.31h12.127V240.55H258.31A2.317,2.317,0,0,0,256,242.859Z",
    transform: "translate(-241.564 -205.222)",
    fill: "#e5eaf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52919",
    "data-name": "Path 52919",
    d: "M185.68,66.685a19.128,19.128,0,0,0-1.829-3.21,5.517,5.517,0,1,1,9.339,0,19.126,19.126,0,0,0-1.829,3.21Z",
    transform: "translate(-174.084 -51.391)",
    fill: "#fad51b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52920",
    "data-name": "Path 52920",
    d: "M206.713,55.628a5.518,5.518,0,0,1,3.955,8.409,19.125,19.125,0,0,0-1.829,3.21h-4.252a19.125,19.125,0,0,0-1.829-3.21,5.518,5.518,0,0,1,3.955-8.409Z",
    transform: "translate(-191.563 -51.953)",
    fill: "#ffe54e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52921",
    "data-name": "Path 52921",
    d: "M228.637,243.569h3.59a.3.3,0,0,0,.3-.3v-1.707h-4.181v1.707A.3.3,0,0,0,228.637,243.569Z",
    transform: "translate(-215.996 -223.838)",
    fill: "#4d5b68",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52922",
    "data-name": "Path 52922",
    d: "M247.545,243.569h2.161a.3.3,0,0,0,.3-.3v-1.707H247.25v1.707A.3.3,0,0,0,247.545,243.569Z",
    transform: "translate(-233.475 -223.838)",
    fill: "#566573",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52923",
    "data-name": "Path 52923",
    d: "M218.773,211.8h4.964a.36.36,0,0,0,.359-.359v-2.075h-5.681v2.075a.36.36,0,0,0,.359.359Z",
    transform: "translate(-206.818 -194.072)",
    fill: "#5f7080",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52924",
    "data-name": "Path 52924",
    d: "M237.681,211.8h3.535a.36.36,0,0,0,.359-.359v-2.075h-4.252v2.075a.36.36,0,0,0,.359.359Z",
    transform: "translate(-224.297 -194.072)",
    fill: "#77899b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52925",
    "data-name": "Path 52925",
    d: "M216.52,119.169V114.54h-.778v4.629h-.907V114.54h-.466a1.373,1.373,0,1,1,1.373-1.373v.466h.778v-.466a1.372,1.372,0,1,1,1.373,1.373h-.466v4.629h-.907Zm.907-6v.466h.466a.466.466,0,1,0-.466-.466Zm-3.058.466h.466v-.466a.466.466,0,1,0-.466.466Z",
    transform: "translate(-201.811 -103.875)",
    fill: "#ffbd1c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52926",
    "data-name": "Path 52926",
    d: "M147.843,11.566a.452.452,0,1,1,.453.783l-1.462.844a.452.452,0,1,1-.453-.783Zm.453,9.008a.452.452,0,1,1-.453.783l-1.462-.844a.452.452,0,1,1,.453-.783Zm.98-4.566a.453.453,0,0,1,0,.907h-1.689a.453.453,0,1,1,0-.907Zm-16.585,5.349a.452.452,0,0,1-.45-.783l1.463-.844a.451.451,0,1,1,.45.783l-1.463.844Zm-1.432-4.442a.453.453,0,1,1,0-.907h1.689a.453.453,0,1,1,0,.907Zm8.555-9.462a.453.453,0,0,1,.907,0V9.142a.453.453,0,0,1-.907,0Zm-4.442,1.432a.451.451,0,1,1,.783-.45L137,9.9a.451.451,0,0,1-.783.45l-.844-1.463Zm-3.133,3.464a.452.452,0,0,1,.453-.783l1.463.844a.452.452,0,0,1-.453.783Zm12.141-3.914a.451.451,0,1,1,.783.45l-.844,1.463a.451.451,0,1,1-.783-.45Z",
    transform: "translate(-125.831 -7)",
    fill: "#ffe54e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52927",
    "data-name": "Path 52927",
    d: "M92.677,264.46a.452.452,0,0,1,0-.9h6.857a.452.452,0,1,1,0,.9Zm17,0a.452.452,0,1,1,0-.9h6.857a.452.452,0,0,1,0,.9Zm-2.559,2.962a.452.452,0,1,1,0-.9h9.416a.452.452,0,1,1,0,.9Zm0,2.962a.452.452,0,1,1,0-.9h9.416a.452.452,0,1,1,0,.9Zm0,2.962a.452.452,0,0,1,0-.9h9.416a.452.452,0,0,1,0,.9Zm0,2.962a.452.452,0,1,1,0-.9h9.416a.452.452,0,1,1,0,.9Zm-14.436-8.888a.452.452,0,0,1,0-.9h9.416a.452.452,0,1,1,0,.9Zm0,2.962a.452.452,0,0,1,0-.9h9.416a.452.452,0,1,1,0,.9Zm0,2.962a.452.452,0,0,1,0-.9h9.416a.452.452,0,1,1,0,.9Zm0,2.963a.452.452,0,0,1,0-.9h9.416a.452.452,0,1,1,0,.9H92.677Z",
    transform: "translate(-90.166 -244.167)",
    fill: "#77899b",
    fillRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52928",
    "data-name": "Path 52928",
    d: "M64.986,221.427H66.2v19.122H64.986Z",
    transform: "translate(-62.676 -205.221)",
    fill: "#e5eaf1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneral);
export default __webpack_public_path__ + "static/media/university-general.d06bd7e7fc87e3aec4feae70eed9619b.svg";
export { ForwardRef as ReactComponent };